import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Configuration} from 'src/app/models/configurations/configuration';
import {FabricService} from '../fabric/fabric.service';
import { ConfigurationState, CONFIGURATION_STATE_DATE_FIELDS } from 'src/app/models/configurations/configuration-state';
import { convertDates } from 'src/app/services/util/utils';
import { map } from 'rxjs/operators';

const SERVICE_NAME = 'mgmt-configuration-resources';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {

  constructor(private fabricService: FabricService) {
  }

  getConfigurations(blueprintId: string): Observable<Configuration[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_configurations', {blueprintId});
  }

  createConfiguration(configuration: Configuration): Observable<Configuration> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_configurations', configuration);
  }

  publishConfiguration(configurationId: string, instanceId: string): Observable<Configuration> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_configurations_id_generate', {
      id: configurationId,
      instanceId
    });
  }

  applyConfiguration(configurationId: string, instanceId: string, skipTest?: string): Observable<Configuration> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_configurations_id_apply', {
      id: configurationId,
      instanceId,
      skipTest
    });
  }
  applyConfigurationSchedule(data): Observable<Configuration> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_configurations_id_apply', data);
  }

  verifyConfiguration(configurationId: string, instanceId: string): Observable<void> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_configurations_id_verify', {id: configurationId, instanceId});
  }

  getConfigurationStates(instanceId: string): Observable<ConfigurationState[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_configurations_state_instanceid', {instanceId})
    .pipe(map(configurationStates => {
      configurationStates.forEach(configurationState => {
        convertDates(configurationState, CONFIGURATION_STATE_DATE_FIELDS);
      });
      return configurationStates;
    }));
  }
}